import React from 'react';
import PropTypes from 'prop-types';
import classes from './ResourceTag.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/utils/Language/Tag-translations';
import Link from '@/helpers/Link';

const ResourceTag = ({ className = '', includeTagIcon = true, linkTo, tag, ...props }) => {
  return (
    <>
      {linkTo ? (
        <Link href={linkTo} className={`${classes.tagLink} ${className}`}>
          {includeTagIcon && <FontAwesomeIcon icon={[`fas`, `tag`]} className={classes.tagIcon} />}
          {t(tag)}
        </Link>
      ) : (
        <span className={className}>
          {includeTagIcon && <FontAwesomeIcon icon={[`fas`, `tag`]} className={classes.tagIcon} />}
          {t(tag)}
        </span>
      )}
    </>
  );
};

ResourceTag.propTypes = {
  className: PropTypes.string,
  linkTo: PropTypes.string,
  tag: PropTypes.string.isRequired
};

export default ResourceTag;
